import React from "react";
import cn from "classnames";
import styles from "./style.module.scss";
const Label = ({ className, children, required, htmlFor, ...rest }) => (React.createElement("label", { htmlFor: htmlFor, className: cn("ukt-label block", className, styles.label, "typography-label"), ...rest },
    children,
    required && React.createElement("span", null, "*")));
export default Label;
//# sourceMappingURL=Label.js.map